/* =====================================================
   RegisterController
   ===================================================== */
angular.module('bizmetryApp').controller('RegisterController', [
  '$scope', '$http', '$q', 'CONFIG', '$location', 'dialogService', '$timeout',
  '$mdSelect', '$mdDialog', 'geoLocationService',
  function ($scope, $http, $q, CONFIG, $location, dialogService, $timeout,
            $mdSelect, $mdDialog, geoLocationService) {

    // ── State ─────────────────────────────────────────────────────────────────
    $scope.formData        = {};
    $scope.countries       = [];
    $scope.states          = [];
    $scope.accountTypes    = [];
    $scope.isSubmitting    = false;
    $scope.phoneValid      = null;    // null=empty | true=valid | false=invalid
    $scope.detectedIso2    = 'US';
    $scope.phoneValidated  = false;   // true = 2FA completado

    // ── Password state — callback desde biz-password-input ───────────────────
    $scope.passwordValue = '';
    $scope.passwordValid = true;

    $scope.onPasswordChange = function (value, valid) {
      $scope.passwordValue = value;
      $scope.passwordValid = valid;
    };

    var _validatedPhone = null;
    var tempToken       = null;

    // ── Watch: resetear validación si cambia el número ─────────────────────
    $scope.$watch('formData.mobilePhone', function (newVal, oldVal) {
      if (newVal !== oldVal && $scope.phoneValidated) {
        $scope.phoneValidated = false;
        _validatedPhone       = null;
      }
    });

    // ── 2FA ───────────────────────────────────────────────────────────────────
    $scope.canValidatePhone = function () {
      return !!(
        $scope.formData.mobilePhone &&
        $scope.phoneValid === true  &&
        $scope.formData.email       &&
        !$scope.phoneValidated
      );
    };

    $scope.phoneNumberChangedAfterValidation = function () {
      return $scope.phoneValidated &&
             $scope.formData.mobilePhone !== _validatedPhone;
    };

    $scope.openTwoFaValidation = function () {
      $mdDialog.show({
        template: [
          '<two-fa-validator',
          '    email="{{ $ctrl.email }}"',
          '    target-number="{{ $ctrl.targetNumber }}"',
          '    on-success="$ctrl.onSuccess()"',
          '    on-cancel="$ctrl.onCancel()">',
          '</two-fa-validator>'
        ].join(''),
        controller: function ($mdDialog) {
          this.email        = $scope.formData.email;
          this.targetNumber = $scope.formData.mobilePhone;
          this.onSuccess    = function () { $mdDialog.hide({ success: true }); };
          this.onCancel     = function () { $mdDialog.cancel(); };
        },
        controllerAs:        '$ctrl',
        clickOutsideToClose: false,
        escapeToClose:       false
      })
      .then(function (result) {
        if (result && result.success) {
          $scope.phoneValidated = true;
          _validatedPhone       = $scope.formData.mobilePhone;
        }
      })
      .catch(function () {});
    };

    // ── Auth ──────────────────────────────────────────────────────────────────
    function authenticateTemporaryUser() {
      return $http.post(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/temp-auth')
        .then(function (response) {
          tempToken = response.data.access_token;
          sessionStorage.setItem('temp_token', tempToken);
        })
        .catch(function (err) { console.error('🚨 Error fetching temp token:', err); });
    }

    function getAuthHeaders() {
      return { headers: { 'Authorization': 'Bearer ' + tempToken } };
    }

    // ── Reference data ────────────────────────────────────────────────────────
    function loadReferenceData() {
      return $q.all([
        $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/COUNTRY', getAuthHeaders())
          .then(function (r) { $scope.countries    = r.data || []; })
          .catch(function () {}),

        $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/USER_TYPE', getAuthHeaders())
          .then(function (r) { $scope.accountTypes = r.data || []; })
          .catch(function () {})
      ]);
    }

    // ── Geo-detection ─────────────────────────────────────────────────────────
    function detectLocation() {
      return geoLocationService.geolocateWithHeaders(getAuthHeaders());
    }

    function prefillLocation(geo) {
      if (!geo || !geo.country_code) return;
      $scope.detectedIso2 = geo.country_code;

      var countryName = (geo.country_name || '').toLowerCase();
      var matched     = $scope.countries.find(function (c) {
        return (c.refObjectLabel || '').toLowerCase() === countryName;
      });
      if (!matched) return;

      $scope.formData.selectedCountry = matched;
      if (!matched.refObjectId) return;

      $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/STATE', {
        params:  { refParentObjectType: 'COUNTRY', refParentObjectId: matched.refObjectId },
        headers: { 'Authorization': 'Bearer ' + tempToken }
      })
      .then(function (r) {
        $scope.states = r.data || [];
        var regionName = (geo.region      || '').toLowerCase();
        var regionCode = (geo.region_code || '').toLowerCase();
        var matchedState = $scope.states.find(function (s) {
          var label = (s.refObjectLabel || '').toLowerCase();
          return label === regionName || label === regionCode;
        });
        if (matchedState) $scope.formData.selectedState = matchedState;
      })
      .catch(function () {});
    }

    // ── Init ──────────────────────────────────────────────────────────────────
    authenticateTemporaryUser()
      .then(function () { return $q.all([loadReferenceData(), detectLocation()]); })
      .then(function (results) { prefillLocation(results[1]); });

    // ── Country / State ───────────────────────────────────────────────────────
    $scope.forceCloseSelect = function () {
      $timeout(function () { try { $mdSelect.hide(); } catch (e) {} }, 0,  false);
      $timeout(function () { try { $mdSelect.hide(); } catch (e) {} }, 60, false);
    };

    $scope.onCountryChange = function () {
      $scope.formData.selectedState = null;
      $scope.states = [];
      var country = $scope.formData.selectedCountry;
      if (!country || !country.refObjectId) return;

      $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/STATE', {
        params:  { refParentObjectType: 'COUNTRY', refParentObjectId: country.refObjectId },
        headers: { 'Authorization': 'Bearer ' + tempToken }
      })
      .then(function (r) { $scope.states = r.data || []; })
      .catch(function () {});
    };

    // ── Form validation ───────────────────────────────────────────────────────
    $scope.isFormValid = function () {
      var f = $scope.formData;

      var phoneProvided = !!f.mobilePhone;
      var phoneOk       = !phoneProvided ||
                          ($scope.phoneValid === true && $scope.phoneValidated);

      // When a phone number is provided, SMS consent must be explicitly given
      var smsConsentOk  = !phoneProvided || !!f.agreeSms;

      // Password obligatorio en register: exige valor válido (no vacío)
      var pwdOk = !!$scope.passwordValue && $scope.passwordValid === true;

      return !!(
        f.firstName           &&
        f.lastName            &&
        f.email               &&
        f.organization        &&
        f.selectedAccountType &&
        f.selectedCountry     &&
        f.selectedState       &&
        pwdOk                 &&
        phoneOk               &&
        smsConsentOk          &&
        f.agreeTerms
      );
    };

    // ── Submit ────────────────────────────────────────────────────────────────
    $scope.register = function () {
      if (!$scope.isFormValid()) return;

      var f = $scope.formData;

      var payload = {
        first_name:   f.firstName,
        last_name:    f.lastName,
        email:        f.email,
        description:  f.accountDescription,
        organization: f.organization,
        account_type: { id: f.selectedAccountType.refId,  name: f.selectedAccountType.refObjectLabel },
        country:      { id: f.selectedCountry.refId,      name: f.selectedCountry.refObjectLabel     },
        state:        { id: f.selectedState.refId,        name: f.selectedState.refObjectLabel       },
        password:     $scope.passwordValue,
        mobile_phone: f.mobilePhone || null,
        sms_consent:  !!f.agreeSms
      };

      $scope.isSubmitting = true;

      $http.post(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/account', payload, getAuthHeaders())
        .then(function (response) {
          sessionStorage.removeItem('temp_token');
          $mdDialog.show({
            templateUrl: '/register/register-success-dialog.html',
            parent:              angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose:       false,
            locals:     { email: f.email },
            controller: function ($scope, $mdDialog, $location, email) {
              $scope.email     = email;
              $scope.goToLogin = function () { $mdDialog.hide(); $location.path('/login'); };
            }
          });
        })
        .catch(function (error) {
          $scope.isSubmitting = false;
          $mdDialog.show({
            templateUrl: '/register/register-error-dialog.html',
            parent:              angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose:       true,
            locals: {
              title:   'Registration Failed',
              message: (error.data && error.data.message) || 'An unexpected error occurred. Please try again.'
            },
            controller: function ($scope, $mdDialog, title, message) {
              $scope.title   = title;
              $scope.message = message;
              $scope.close   = function () { $mdDialog.hide(); };
            }
          });
        });
    };

    // ── Terms & Privacy ───────────────────────────────────────────────────────
    $scope.openTermsDialog = function (e) {
      e && e.preventDefault(); e && e.stopPropagation();
      $mdDialog.show({
        templateUrl:         '/register/terms-dialog.html',
        controller:          function ($scope, $mdDialog) { $scope.close = function () { $mdDialog.hide(); }; },
        parent:              angular.element(document.body),
        targetEvent:         e,
        clickOutsideToClose: true,
        escapeToClose:       true,
        disableParentScroll: false
      });
    };

    $scope.openPrivacyDialog = function (e) {
      e && e.preventDefault(); e && e.stopPropagation();
      $mdDialog.show({
        templateUrl:         '/register/privacy-policy-dialog.html',
        controller:          function ($scope, $mdDialog) { $scope.close = function () { $mdDialog.hide(); }; },
        parent:              angular.element(document.body),
        targetEvent:         e,
        clickOutsideToClose: true,
        escapeToClose:       true,
        disableParentScroll: false
      });
    };

  }
]);